<template>
  <div class="col-span-2">
    <ul class="text-center font-light" :class="isDark? 'text-orange-600':'text-white'">
      <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ContactFormErrors",
  // TODO: design errors
  props: ['errors', 'isDark']
}
</script>

<style scoped>

</style>
